import React, { useMemo } from "react";
import { useHtmlClassService } from "../../_core/MetronicLayout";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  function getVersion(version) {
    try {
      return version.slice(0, 7);
    } catch (error) {
      console.log("version not loaded");
    }
  }

  return (
    <div
      className={`footer bg-white py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold mr-2">Verzija: {getVersion(process.env?.REACT_APP_VERCEL_GIT_COMMIT_SHA)}</span>
        </div>
        <div className="nav nav-dark order-1 order-md-2">
          <span className="text-muted font-weight-bold nav-link px-3">{today.toString()}</span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-link"
            href="https://www.betasoft.rs/"
          >
            &copy;{" "}BetaSoft
          </a>
          {/* <a 
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link px-3"
          >
            Team
          </a>
          <a 
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pl-3 pr-0"
          >
            Contact
          </a> */}
        </div>
      </div>
    </div>
  );
}
